import { translateFr as tfr } from "@/i18n";
import { dateLocale } from "@/lib/utils";
export const CONTRACT_STATUS = {
  draft: { label: tfr("Brouillon"), dot: "#9CA3AF", cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25" },
  pending_signature: { label: tfr("En attente de signature"), dot: "#F5A524", cls: "bg-amber-500/10 text-amber-400 border-amber-500/25" },
  partially_signed: { label: tfr("Partiellement signé"), dot: "#3B82F6", cls: "bg-blue-500/10 text-blue-400 border-blue-500/25" },
  signed: { label: tfr("Signé"), dot: "#22C55E", cls: "bg-green-500/10 text-green-400 border-green-500/25" },
  upcoming: { label: tfr("À venir"), dot: "#38BDF8", cls: "bg-sky-500/10 text-sky-400 border-sky-500/25" },
  active: { label: "Actif", dot: "#10B981", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25" },
  expired: { label: tfr("Expiré"), dot: "#FB923C", cls: "bg-orange-500/10 text-orange-400 border-orange-500/25" },
  archived: { label: tfr("Archivé"), dot: "#71717A", cls: "bg-zinc-500/10 text-zinc-500 border-zinc-500/20" },
  cancelled: { label: tfr("Annulé"), dot: "#E5484D", cls: "bg-red-500/10 text-red-400 border-red-500/25" },
};

export const CONTRACT_TYPES = [
  { id: "representation", label: tfr("Mandat de représentation") },
  { id: "transfer", label: tfr("Contrat de transfert") },
  { id: "employment", label: tfr("Contrat de travail") },
  { id: "sponsoring", label: tfr("Contrat de sponsoring") },
  { id: "image_rights", label: tfr("Droits à l'image") },
  { id: "amendment", label: tfr("Avenant") },
  { id: "other", label: "Autre" },
];
export const typeLabel = (id) => CONTRACT_TYPES.find((t) => t.id === id)?.label || "Autre";

export const SIGNATORY_ROLES = [
  { id: "player", label: tfr("Athlète") },
  { id: "agent", label: "Agent" },
  { id: "club", label: "Club" },
  { id: "lawyer", label: "Avocat" },
  { id: "guardian", label: tfr("Représentant légal") },
  { id: "sponsor", label: "Sponsor" },
  { id: "other", label: "Autre" },
];
export const roleLabel = (id) => SIGNATORY_ROLES.find((r) => r.id === id)?.label || "Autre";

export const SIG_STATUS = {
  pending: { label: tfr("En attente"), cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25" },
  notified: { label: tfr("Invitation envoyée"), cls: "bg-amber-500/10 text-amber-400 border-amber-500/25" },
  viewed: { label: tfr("Consulté"), cls: "bg-blue-500/10 text-blue-400 border-blue-500/25" },
  signed: { label: tfr("Signé"), cls: "bg-green-500/10 text-green-400 border-green-500/25" },
  declined: { label: tfr("Refusé"), cls: "bg-red-500/10 text-red-400 border-red-500/25" },
};

export const DOC_KINDS = [
  { id: "contract", label: tfr("Contrat principal") },
  { id: "annex", label: "Annexe" },
  { id: "amendment", label: tfr("Avenant") },
  { id: "identity", label: tfr("Pièce d'identité") },
  { id: "proof", label: "Justificatif" },
  { id: "other", label: "Autre" },
];
export const docKindLabel = (id) => DOC_KINDS.find((k) => k.id === id)?.label || "Autre";

export function fmtMoney(cents, currency = "EUR") {
  if (cents == null || cents === "") return null;
  return new Intl.NumberFormat(dateLocale(), { style: "currency", currency, maximumFractionDigits: 0 }).format(cents / 100);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(dateLocale(), { day: "numeric", month: "short", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(dateLocale(), { day: "numeric", month: "short", year: "numeric" }) +
    " · " + d.toLocaleTimeString(dateLocale(), { hour: "2-digit", minute: "2-digit" });
}

export function fmtSize(bytes) {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "?";

export const shortHash = (h) => (h ? `${h.slice(0, 8)}…${h.slice(-6)}` : "—");

export const PROC_STATUS = {
  draft: { label: tfr("Brouillon"), cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25" },
  ready: { label: tfr("Prêt à envoyer"), cls: "bg-blue-500/10 text-blue-400 border-blue-500/25" },
  sent: { label: tfr("Envoyé"), cls: "bg-amber-500/10 text-amber-400 border-amber-500/25" },
  in_progress: { label: tfr("Signatures en cours"), cls: "bg-amber-500/10 text-amber-400 border-amber-500/25" },
  completed: { label: tfr("Terminé"), cls: "bg-green-500/10 text-green-400 border-green-500/25" },
  declined: { label: tfr("Refusé"), cls: "bg-red-500/10 text-red-400 border-red-500/25" },
  expired: { label: tfr("Expiré"), cls: "bg-orange-500/10 text-orange-400 border-orange-500/25" },
  cancelled: { label: tfr("Annulé"), cls: "bg-zinc-500/10 text-zinc-500 border-zinc-500/20" },
  failed: { label: tfr("Échec"), cls: "bg-red-500/10 text-red-400 border-red-500/25" },
};

export const SIGNER_STATUS = {
  pending: { label: tfr("En attente"), cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25", dot: "#9CA3AF" },
  invited: { label: tfr("Invitation envoyée"), cls: "bg-amber-500/10 text-amber-400 border-amber-500/25", dot: "#F5A524" },
  opened: { label: tfr("Document consulté"), cls: "bg-blue-500/10 text-blue-400 border-blue-500/25", dot: "#3B82F6" },
  signed: { label: tfr("Signé"), cls: "bg-green-500/10 text-green-400 border-green-500/25", dot: "#22C55E" },
  declined: { label: tfr("Refusé"), cls: "bg-red-500/10 text-red-400 border-red-500/25", dot: "#E5484D" },
  expired: { label: tfr("Expiré"), cls: "bg-orange-500/10 text-orange-400 border-orange-500/25", dot: "#FB923C" },
  failed: { label: tfr("Échec"), cls: "bg-red-500/10 text-red-400 border-red-500/25", dot: "#E5484D" },
};

export const SIGNER_ROLES = [
  { id: "player", label: tfr("Athlète") },
  { id: "agent", label: "Agent" },
  { id: "club", label: "Club" },
  { id: "sponsor", label: "Sponsor" },
  { id: "federation", label: tfr("Fédération") },
  { id: "lawyer", label: "Avocat" },
  { id: "guardian", label: tfr("Représentant légal") },
  { id: "other", label: "Autre partie" },
];
export const signerRoleLabel = (id) => SIGNER_ROLES.find((r) => r.id === id)?.label || id;
